/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listIncidentsParamsViewDefault = `active`;
export const listIncidentsParamsCursorMax = 1024;

export const listIncidentsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listIncidentsParamsLimitDefault = 50;
export const listIncidentsParamsLimitMax = 100;

export const ListIncidentsParams = zod.object({
  view: zod.enum(['active', 'all']).default(listIncidentsParamsViewDefault),
  cursor: zod
    .string()
    .min(1)
    .max(listIncidentsParamsCursorMax)
    .regex(listIncidentsParamsCursorRegExp)
    .optional(),
  limit: zod.int().min(1).max(listIncidentsParamsLimitMax).default(listIncidentsParamsLimitDefault),
});

export type ListIncidentsParams = zod.input<typeof ListIncidentsParams>;
export type ListIncidentsParamsOutput = zod.output<typeof ListIncidentsParams>;
